var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAprYieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FAF4DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31019 12.8373L5.14749 13.0271L5.52712 13.3525L5.68981 13.1627L5.5 13L5.31019 12.8373ZM8.71429 9.25L8.9041 9.0873L8.71429 8.86585L8.52447 9.0873L8.71429 9.25ZM10.6429 11.5L10.453 11.6627L10.6429 11.8841L10.8327 11.6627L10.6429 11.5ZM14.7493 6.98083C14.7387 6.84316 14.6185 6.74015 14.4808 6.75074L12.2375 6.9233C12.0998 6.93389 11.9968 7.05408 12.0074 7.19174C12.018 7.32941 12.1381 7.43242 12.2758 7.42183L14.2699 7.26844L14.4233 9.26255C14.4339 9.40021 14.5541 9.50323 14.6917 9.49264C14.8294 9.48205 14.9324 9.36186 14.9218 9.2242L14.7493 6.98083ZM5.5 13L5.68981 13.1627L8.9041 9.4127L8.71429 9.25L8.52447 9.0873L5.31019 12.8373L5.5 13ZM8.71429 9.25L8.52447 9.4127L10.453 11.6627L10.6429 11.5L10.8327 11.3373L8.9041 9.0873L8.71429 9.25ZM10.6429 11.5L10.8327 11.6627L14.6898 7.1627L14.5 7L14.3102 6.8373L10.453 11.3373L10.6429 11.5Z",
    fill: "#FA8E16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5H16",
    stroke: "#FA8E16",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprYieldIcon);
export default __webpack_public_path__ + "static/media/aprYieldIcon.11dab3568c50f0744039cf679e9a0e54.svg";
export { ForwardRef as ReactComponent };